module.exports = "https://static.wmbcdn.com/uniweb/images/3638c2da95fbeac70111348dac8fba3e.svg";